import { lazy, Suspense, type ComponentProps } from "react";

import { isDashboardDataProviderEnabled } from "../providers/aws/client";
import type { EchoShareStatus as EchoShareStatusComponent } from "./EchoShareStatus";

// The Echo page ships in the entry chunk; the share badge, its staff dialog
// and the share helpers load on demand so they never count against the entry
// bundle budget (scripts/bundle-budget.json).
const EchoShareStatus = lazy(() =>
  import("./EchoShareStatus").then((module) => ({
    default: module.EchoShareStatus,
  })),
);

/** ESH-063 "Shared · N views" badge (+ admin Disable link), loaded lazily. */
export const LazyEchoShareStatus = (
  props: ComponentProps<typeof EchoShareStatusComponent>,
) => {
  const { record } = props;
  if (!isDashboardDataProviderEnabled()) return null;
  if (!record.whatsapp_user_id && record.contact_id == null) return null;
  return (
    <Suspense fallback={null}>
      <EchoShareStatus {...props} />
    </Suspense>
  );
};
